import React, { createContext, useContext, useState, useCallback } from "react";

const NoticeContext = createContext(null);

export const NoticeProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const openNotice = useCallback(() => setOpen(true), []);
  const closeNotice = useCallback(() => setOpen(false), []);
  return (
    <NoticeContext.Provider value={{ open, setOpen, openNotice, closeNotice }}>
      {children}
    </NoticeContext.Provider>
  );
};

export const useNotice = () => {
  const ctx = useContext(NoticeContext);
  if (!ctx) throw new Error("useNotice must be used within NoticeProvider");
  return ctx;
};
